(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/services/assets/hooks/use-active-competition-id.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/services/assets/hooks/use-active-competition-id.js');
"use strict";

const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const selectActiveCompetitionId = svs.components.marketplaceCompetition.services.selectors.competitionSelectors.selectActiveCompetitionId;
const useActiveCompetitionId = () => useSelector(selectActiveCompetitionId);
setGlobal('svs.components.marketplaceCompetition.services.hooks.useActiveCompetitionId', useActiveCompetitionId);

 })(window);